import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';
import { Company, CompanyState } from './company.interface';
// Thunks para Usuarios
import { fetchCompanies, fetchCompanyById, createCompany, updateCompany } from './companyThunks';
import { APIResponse } from '@/types/custom-http';


const initialState: CompanyState = {
  items: [],
  selectedCompany: null,
  loading: false,
  error: null,
};



// Slice
const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    clearCompanies: (state) => {
      state.items = [];
    },
    clearSelectedCompany: (state) => {
      state.selectedCompany = null;
    },
    clearCompanyError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action: PayloadAction<APIResponse<Company[]>>) => {
        state.loading = false;
        if(action.payload.data){
          state.items = action.payload.data;
        }
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      .addCase(fetchCompanyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyById.fulfilled, (state, action: PayloadAction<APIResponse<Company>>) => {
        state.loading = false;
        if(action.payload.data){
          state.selectedCompany = action.payload.data;
        }
      })
      .addCase(fetchCompanyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      .addCase(createCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCompany.fulfilled, (state, action: PayloadAction<APIResponse<Company>>) => {
        state.loading = false;
        if(action.payload.data){
          state.items.push(action.payload.data);
        }
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      .addCase(updateCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompany.fulfilled, (state, action: PayloadAction<APIResponse<Company>>) => {
        state.loading = false;
        const index = state.items.findIndex(elem => elem.id === action.payload.data?.id);
        if (index !== -1 && action.payload.data) {
          state.items[index] = action.payload.data;
        }
        if (state.selectedCompany && state.selectedCompany.id === action.payload.data?.id) {
          state.selectedCompany = action.payload.data;
        }
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })
      
  },
});

// Selectors
export const selectCompanies = (state: RootState) => state.company.items;
export const selectedCompany = (state: RootState) => state.company.selectedCompany;
export const selectCompanyLoading = (state: RootState) => state.company.loading;
export const selectCompanyError = (state: RootState) => state.company.error;

// Actions
export const { clearCompanies, clearSelectedCompany, clearCompanyError} = companySlice.actions;

export default companySlice.reducer;